import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable, MASK_DATE } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { _ProductionRoute, _single } from "../../../core/services/dataBean/EntityCatalog";
import { Labour } from "../ManufacturingStandars/Labour/Labour";
import { BasicButton } from "../../theme/Component/BasicButton";
import usePaginator from "../../theme/Component/usePaginator";
import { toast } from "react-toastify";
import { FileInput } from "../../theme/Component/FileInput";
import { CostingCenterSelect } from "../../erp/cellEditor/CostingCenter/CostingCenterSelect";
import { InputMoney } from "../../theme/Input/InputMoney";
import { _ExpProdRoute, _UnitaryValue, _UnitaryValueAll } from "../../../core/services/dataBean/EntityCatalogVdos";
import { BasicSwitch } from "../../theme/Component/BasicSwitch";

export const ProductionRoute = () => {

    const { instance, lista, setLista, bean, setBean, handleChange } = useDataBean(_ProductionRoute);
    const AsingValue = useDataBean(_UnitaryValue);
    const AsingValueAll = useDataBean(_UnitaryValueAll);
    const ExpProdRoute = useDataBean(_ExpProdRoute);
    const [formato, setFormato] = useState<any>([]);
    const [regexStr, setregexStr] = useState<string>(null)
    const [modalexcel, setModalexcel] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalexpexcel, setModalexpexcel] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalasingvalueAll, setModalasingvalueAll] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalasingvalue, setModalasingvalue] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [modalTask, setModalTask] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });
    const [modalImport, setModalImport] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [modalVisor, setModalVisor] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [form, setForm] = useState<any>({
        ReplaceAll: false,

    })
    const [formtwo, setFormtwo] = useState<any>({
        ReplaceAll: false,

    })
    const paginador = usePaginator();
    const [records, setRecords] = useState<number>(15);
    useEffect(() => {
        getLista();
    }, [paginador.page])


    const getLista = () => {

        instance.getProductionRouteCatalogdos(regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    setLista(resp.List)
                }
            }
        ).catch(
            (err: any) => {
                toast.error(err)
            }
        )

    }
    const exportProductionRoute = () => {

        ExpProdRoute.instance.exportProductionRoute(bean.IDProductionRoute).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Exportado')
                    setFormato(resp[0]);
                    setModalexcel({ ...modalexcel, "view": false });
                    setModalexpexcel({ ...modalexpexcel, "view": true });
                }
            }
        ).catch(
            (err: any) => {
                toast.error(err)
            }
        )

    }
    const create = () => {
        setBean({
            IDEmployee: _single.getAccountID(),
        });
        setModal({ ...modal, "view": true, "name": "Nueva Ruta de Producción" });
    }
    const deleteItem = () => {
        instance.deleteProductionRoute(bean.IDProductionRoute).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        ).catch(
            (err: any) => { console.log(err) }
        )
    }
    const editaItem = () => {
        instance.updateProductionRoute(bean).then(
            (resp) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(
            (err: any) => { console.log(err) }
        )
    }

    const head = [
        { title: 'ID', property: 'IDProductionRoute', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        // { title: 'Centro de Costo', property: 'CostingCenterStr', visible: true },
        { title: 'Empleado', property: 'EmployeeName', visible: true },
        { title: 'Fecha Creación', property: 'Since', visible: true, mask: MASK_DATE },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create },
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Importar Operaciones a Ruta de Producción', icono: 'ri-file-upload-line', visible: _single.canCreate(), evento: () => { setModalImport({ ...modalImport, "name": `Importar Operaciones a Ruta de Producción `, "view": true }) } },
            { titulo: 'Labores/Tareas a Ejecutar', icono: 'ri-task-line', visible: _single.canDelete(), evento: () => { setModalTask({ ...modalTask, "view": true, "name": `Labores/Tareas a ejecutar de ${bean.Name}` }) } },
            { titulo: 'Asignar Valor Unitario a la Ruta de Producción', icono: 'ri-file-upload-line', visible: _single.canCreate(), evento: () => { setModalasingvalue({ ...modalasingvalue, "name": `Asignar Valor Unitario a toda la Ruta de Producción `, "view": true }) } },
            { titulo: 'Exportar a Excel Listado Operacional', icono: 'ri-file-upload-line', visible: _single.canCreate(), evento: () => { setModalexcel({ ...modalexcel, "view": true }) } },
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [doc, setDoc] = useState<any>({})

    const importActions = () => {
        instance.imporLabourCatalog(bean.IDProductionRoute, doc.FileName, doc.Directory, null).then(
            (resp) => {
                getLista();
                setResponse(resp);
                setModalVisor({ ...modalVisor, "view": true })
                setModalImport({ ...modalImport, "view": false });
            }
        ).catch(
            err => { toast.error(err) }
        )
    }
    const verupdateall = () => {

        setModalasingvalueAll({ ...modalasingvalueAll, "view": true });

    }
    const setUnitaryValueToProductionRoute = () => {
        AsingValue.instance.setUnitaryValueToProductionRoute(bean.IDProductionRoute, AsingValue.bean.UnitaryValue, form.ReplaceAll).then(
            (resp) => {
                console.log(resp)
                toast.success('Valor Asignado')
                setModalasingvalue({ ...modalasingvalue, "view": false });
            }
        ).catch(
            err => { toast.error(err) }
        )
    }
    const setUnitaryValueToAllProductionRoute = () => {
        AsingValueAll.instance.setUnitaryValueToAllProductionRoute(AsingValueAll.bean.UnitaryValue, formtwo.ReplaceAll).then(
            (resp) => {
                console.log(resp)
                toast.success('Valor Asignado a Todas las Rutas')
                setModalasingvalueAll({ ...modalasingvalueAll, "view": false });
            }
        ).catch(
            err => { toast.error(err) }
        )
    }
    const [response, setResponse] = useState<any>([]);
    const [missingFields, setMissingFields] = useState<string[]>([]);

    return (
        <BasicPage titulo="Rutas de Producción">
            <div className="row">
                <div className="col-md-4">

                    <label>Búsqueda por Texto</label>
                    <input type="text" name="Name" className="form-control" value={regexStr} onChange={(e: any) => { setregexStr(e.target.value) }} />

                </div>
                <div className="col-md-2 mt-4 p-2">
                    <BasicButton eventClick={getLista} icon="bx bx-zoom-in" >
                        Buscar
                    </BasicButton>
                </div>
                <div className="col-md-4 mt-4 p-2">
                    <BasicButton icon="ri-contacts-book-upload-fill" clase="btn btn-outline-primary btn-border" eventClick={verupdateall}>
                        Asignar Valor Unitario a Todas las Rutas de Producción
                    </BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page}
                        next={paginador.next}
                        back={paginador.back}
                        records={paginador}></BasicTable>
                </div>

                <div className="col-md-12">

                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={bean.Name} onChange={handleChange} />
                            </div>

                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea name="Description" className="form-control" value={bean.Description} onChange={handleChange} />
                            </div>
                        </div>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {bean.Name}</strong>
                    </ModalConfirm>
                </div>

                <div className="col-md-12">
                    <Modal modal={modalTask} updateModal={setModalTask} >
                        <Labour IDProductionRoute={bean.IDProductionRoute} />
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={modalasingvalue} updateModal={setModalasingvalue} eventModal={setUnitaryValueToProductionRoute} onSubmitLabel="Asignar Valor" >
                        <>
                            <div className="row">
                                <div className="col-md-12">
                                    <InputMoney _label="Valor Unitario" _value={AsingValue.bean.UnitaryValue} onChange={(e: any) => { AsingValue.setBean({ ...AsingValue.bean, "UnitaryValue": e }) }} />
                                </div>
                                <div className="col-md-6">
                                    <BasicSwitch label="Reemplazar Valores Existentes" estado={form.ReplaceAll} eventChange={(e) => { setForm({ ...form, "ReplaceAll": e }) }} />
                                </div>
                            </div>
                        </>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={modalasingvalueAll} updateModal={setModalasingvalueAll} eventModal={setUnitaryValueToAllProductionRoute} onSubmitLabel="Asignar Valor a Todas las Rutas" >
                        <>
                            <div className="row">
                                <div className="col-md-12">
                                    <InputMoney _label="Valor Unitario" _value={AsingValueAll.bean.UnitaryValue} onChange={(e: any) => { AsingValueAll.setBean({ ...AsingValueAll.bean, "UnitaryValue": e }) }} />
                                </div>
                                <div className="col-md-6">
                                    <BasicSwitch label="Reemplazar Valores Existentes" estado={formtwo.ReplaceAll} eventChange={(e) => { setFormtwo({ ...formtwo, "ReplaceAll": e }) }} />
                                </div>
                            </div>
                        </>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={modalexcel} updateModal={setModalexcel} eventModal={exportProductionRoute} onSubmitLabel="Exportar a Excel Listado Operacional" >
                        <>
                            <div className="row">
                                <strong>Exportar a Excel {bean.IDProductionRoute} - {bean.Name} ?</strong>
                            </div>
                        </>
                    </Modal>
                </div>
                <Modal modal={modalexpexcel} updateModal={setModalexpexcel}>
                    <>
                        <div className="row">
                            <div className="col-md-12">
                                {formato?.DataBeanProperties?.URLLink && (
                                    // <PrintJson json={formato.DataBeanProperties.URLLink} />
                                    <div className="row">
                                        <div className="col-md-12 mt-3">
                                            <label>Descarga en el Siguiente Link:*</label>
                                        </div>
                                        <div className="col-md-6 mt-3">
                                            <a href={formato.DataBeanProperties.URLLink} target="_blank" rel="noopener noreferrer">
                                                <strong>📄 {formato.DataBeanProperties.Filename}</strong>
                                            </a>
                                        </div>
                                    </div>

                                )}
                            </div>
                        </div>

                    </>
                </Modal>
                <div className="col-md-12">
                    <Modal modal={modalImport} updateModal={setModalImport} eventModal={importActions} onSubmitLabel="Importar" >
                        <FileInput onCreate={({ Media, MediaContext }) => {
                            setDoc({
                                FileName: Media,
                                Directory: MediaContext
                            })
                        }} />
                    </Modal>
                </div>

                <div className="col-md-12">

                    <Modal modal={modalVisor} updateModal={setModalVisor} >
                        <div className="row">
                            <div className="col-md-12">
                                <ul className="group-list">
                                    {response.map((item: any, index: number) => {
                                        return (
                                            <li key={index} className="group-list-item">{item}</li>
                                        )
                                    })}
                                </ul>

                            </div>
                        </div>
                    </Modal>
                </div>

            </div>
        </BasicPage>
    )
}